import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import i18n from 'utils/I18n';
import LoginMethodContactModal from 'component/account/LoginMethodContactModal';
import CustomerContactModal from './CustomerContactModal';
import {
  PRIMARY_SIGN_UP_METHOD,
  USE_RECAPTCHA,
  RECAPTCHA_SITE_KEY,
} from 'utils/Config';
import {
  MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP,
  LOGIN_SHOW_EDIT_BUTTON,
  LOGIN_SHOW_CUSTOMER_SERVICE,
  SECOND_CONTACT_SHOW,
  SECOND_CONTACT_SHOW_EDIT_BUTTON,
  SECOND_CONTACT_SHOW_CUSTOMER_SERVICE,
  SECOND_CONTACT_OPTIONAL,
} from 'utils/LoginOrSecondContactUtils';
import {
  CUSTOMER_SIGN_UP_METHOD,
  CustomerFieldName,
  GenderType,
  ProfileEditState,
  ProfileEditType,
} from 'utils/CustomEnums';
import {
  FirstNameSection,
  LastNameSection,
  GenderSection,
  BirthdaySection,
  SingleLoginOrContactSection
} from './MyAccountDefaultSection';
import './MyAccountInfoSection.scss';

import checkCircle from 'assets/images/check-circle.png';
import { ReactComponent as NoticeImg } from 'assets/images/Info.svg';

const LoginMethod = ({
  userInfo,
  email,
  showEmail,
  countryCodeAndPhoneNumber,
  showMobile,
  signUpMethod,
  showAddLoginMethodButton,
  showSecondLoginMethodModal,
  contactForDirectMarketingEditState,
  setEditType,
  hideSecondLoginMethodModal,
  setShowCustomerContactModal,
}) => {
  const { tempEmailAddress, tempCountryCode, tempPhoneNumber } = userInfo;
  const secondLoginMethod = signUpMethod === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER
    ? CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
    : CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER;

  const addSecondLoginMethodItem = () => {
    if (!showAddLoginMethodButton) {
      return <></>
    }

    let tempContact = ""
    if (
      secondLoginMethod === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER
      && tempPhoneNumber
    ) {
      tempContact = `${tempCountryCode || ""} ${tempPhoneNumber}`
    } else if (
      secondLoginMethod === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
      && tempEmailAddress
    ) {
      tempContact = tempEmailAddress
    }
    return (
      <>
        <div className='second-contact-line'>
          {tempContact &&
            <div className='field-text temp-second-contact'>
              {tempContact}
            </div>
          }
          <button
            className="add-another-btn button-small subheading"
            onClick={() =>
              showSecondLoginMethodModal(secondLoginMethod)
            }
          >
            {tempContact ? i18n.t('verify_now') : i18n.t('settings_login_add_second_method')}
          </button>
        </div>
        {MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP && tempContact
          ? <div className='second-contact-verify-tips tag-menu-1'>
            <NoticeImg className="notice-img" />
            {i18n.t('sencond_login_method_tips')}
          </div> : null}
      </>
    )
  }
  return (
    <Col className="common-account-col">
      <div className="common-account-item">
        <div className="common-item-title subheading">
          {i18n.t('settings_login_and_contact')}
        </div>
        <SingleLoginOrContactSection
          show={[
            CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS,
            CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS
          ].includes(PRIMARY_SIGN_UP_METHOD) && showEmail}
          contactValue={email}
          showEdit={LOGIN_SHOW_EDIT_BUTTON}
          showCustomerService={LOGIN_SHOW_CUSTOMER_SERVICE}
          contactForDirectMarketingEditState={contactForDirectMarketingEditState}
          setEditType={setEditType}
          showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS)}
          hideSecondLoginMethodModal={hideSecondLoginMethodModal}
          setShowCustomerContactModal={setShowCustomerContactModal}
        />
        <SingleLoginOrContactSection
          show={[
            CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER,
            CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS
          ].includes(PRIMARY_SIGN_UP_METHOD) && showMobile}
          contactValue={countryCodeAndPhoneNumber}
          showEdit={LOGIN_SHOW_EDIT_BUTTON}
          showCustomerService={LOGIN_SHOW_CUSTOMER_SERVICE}
          contactForDirectMarketingEditState={contactForDirectMarketingEditState}
          setEditType={setEditType}
          showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER)}
          hideSecondLoginMethodModal={hideSecondLoginMethodModal}
          setShowCustomerContactModal={setShowCustomerContactModal}
        />
        {userInfo?.shopifyLinked ? (
          <label className="customer-detail-link-tip caption">
            <img class="customer-detail-field-icon" alt="" src={checkCircle}/>
            Linked with online store. Can earn rewards via online purchase.
          </label>
        ) : null}
        {addSecondLoginMethodItem()}
      </div>
    </Col>
  );
};

const ContactForDirectMarketing = ({
  contactForDirectMarketingEditState,
  setEditType,
  showEmail,
  email,
  showMobile,
  countryCodeAndPhoneNumber,
  showAddSecondContactButton,
  showSecondLoginMethodModal,
  hideSecondLoginMethodModal,
  setShowCustomerContactModal,
}) => {
  const directMarketingTitle = i18n.t('settings_contact_for_direct_marketing') + (SECOND_CONTACT_OPTIONAL ? i18n.t('personal_info_optional') : "")
  return (
    <Col className="common-account-col">
      <div className="common-account-item">
        <div className="common-item-title subheading">
          {directMarketingTitle}
        </div>
        {
          PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
            ? <SingleLoginOrContactSection
              show={showMobile}
              contactValue={countryCodeAndPhoneNumber}
              showEdit={SECOND_CONTACT_SHOW_EDIT_BUTTON}
              showCustomerService={SECOND_CONTACT_SHOW_CUSTOMER_SERVICE}
              contactForDirectMarketingEditState={contactForDirectMarketingEditState}
              setEditType={setEditType}
              showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER)}
              hideSecondLoginMethodModal={hideSecondLoginMethodModal}
              setShowCustomerContactModal={setShowCustomerContactModal}
            />
            : <SingleLoginOrContactSection
              show={showEmail}
              contactValue={email}
              showEdit={SECOND_CONTACT_SHOW_EDIT_BUTTON}
              showCustomerService={SECOND_CONTACT_SHOW_CUSTOMER_SERVICE}
              contactForDirectMarketingEditState={contactForDirectMarketingEditState}
              setEditType={setEditType}
              showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS)}
              hideSecondLoginMethodModal={hideSecondLoginMethodModal}
              setShowCustomerContactModal={setShowCustomerContactModal}
            />
        }

        {showAddSecondContactButton && (
          <button
            className="add-another-btn button-small subheading"
            onClick={() => showSecondLoginMethodModal(
              PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
                ? CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER
                : CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
            )}
          >
            {i18n.t('additional_contact_title')}
          </button>
        )}
      </div>
    </Col>
  );
};

const LoginOrContactSectionWithGenderAndBirthday = ({
  language,
  contactForDirectMarketingEditState,
  setEditType,
  email,
  showEmail,
  countryCodeAndPhoneNumber,
  showMobile,
  signUpMethod,
  showAddLoginMethodButton,
  showAddSecondContactButton,
  showSecondLoginMethodModal,
  hideSecondLoginMethodModal,
  setShowCustomerContactModal,
  genderConfig,
  genderEditState,
  userInfo,
  selectedGender,
  setSelectedGender,
  birthdayConfig,
  birthdayEditState,
  birthday,
  setBirthday,
}) => {
  const genderList = useMemo(() => [
    {
      name: i18n.t('personal_info_male'),
      pk: GenderType.Male,
    },
    {
      name: i18n.t('personal_info_female'),
      pk: GenderType.Female,
    },
    {
      name: i18n.t('personal_info_not_disclosed'),
      pk: GenderType.NotDisclosed,
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [language],
  );

  const displayGender = useMemo(() => {
    const userGender = userInfo.gender;
    if (userGender === GenderType.Female) {
      return i18n.t('personal_info_female');
    }
    if (userGender === GenderType.Male) {
      return i18n.t('personal_info_male');
    }
    if (userGender === GenderType.NotDisclosed) {
      return i18n.t('personal_info_not_disclosed');
    }
    return i18n.t('not_provided');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.gender, language]);

  // show second contact section
  if (!MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP && SECOND_CONTACT_SHOW) {
    return (
      <>
        <Row>
          <LoginMethod
            userInfo={userInfo}
            contactForDirectMarketingEditState={
              contactForDirectMarketingEditState
            }
            setEditType={setEditType}
            email={email}
            showEmail={showEmail}
            countryCodeAndPhoneNumber={countryCodeAndPhoneNumber}
            showMobile={showMobile}
            signUpMethod={signUpMethod}
            showAddLoginMethodButton={showAddLoginMethodButton}
            showSecondLoginMethodModal={showSecondLoginMethodModal}
            hideSecondLoginMethodModal={hideSecondLoginMethodModal}
            setShowCustomerContactModal={setShowCustomerContactModal}
          />
          <ContactForDirectMarketing
            contactForDirectMarketingEditState={
              contactForDirectMarketingEditState
            }
            setEditType={setEditType}
            showEmail={showEmail}
            email={email}
            showMobile={showMobile}
            countryCodeAndPhoneNumber={countryCodeAndPhoneNumber}
            showAddSecondContactButton={showAddSecondContactButton}
            showSecondLoginMethodModal={showSecondLoginMethodModal}
            hideSecondLoginMethodModal={hideSecondLoginMethodModal}
            setShowCustomerContactModal={setShowCustomerContactModal}
          />
        </Row>
        <Row>
          <GenderSection
            show={genderConfig?.show}
            mandatory={genderConfig?.mandatory}
            editable={genderConfig?.editable}
            genderEditState={genderEditState}
            setEditType={setEditType}
            genderList={genderList}
            userInfo={userInfo}
            selectedGender={selectedGender}
            setSelectedGender={setSelectedGender}
            displayGender={displayGender}
          />
          <BirthdaySection
            show={birthdayConfig?.show}
            mandatory={birthdayConfig?.mandatory}
            editable={birthdayConfig?.editable}
            birthdayEditState={birthdayEditState}
            setEditType={setEditType}
            userInfo={userInfo}
            birthday={birthday}
            setBirthday={setBirthday}
            language={language}
          />
        </Row>
      </>
    )
  }

  return (
    <>
      <Row>
        <LoginMethod
          userInfo={userInfo}
          contactForDirectMarketingEditState={
            contactForDirectMarketingEditState
          }
          setEditType={setEditType}
          email={email}
          showEmail={showEmail}
          countryCodeAndPhoneNumber={countryCodeAndPhoneNumber}
          showMobile={showMobile}
          signUpMethod={signUpMethod}
          showAddLoginMethodButton={showAddLoginMethodButton}
          showSecondLoginMethodModal={showSecondLoginMethodModal}
          hideSecondLoginMethodModal={hideSecondLoginMethodModal}
          setShowCustomerContactModal={setShowCustomerContactModal}
        />
        <GenderSection
          show={genderConfig?.show}
          mandatory={genderConfig?.mandatory}
          editable={genderConfig?.editable}
          genderEditState={genderEditState}
          setEditType={setEditType}
          genderList={genderList}
          userInfo={userInfo}
          selectedGender={selectedGender}
          setSelectedGender={setSelectedGender}
          displayGender={displayGender}
        />
      </Row>
      <Row>
        <BirthdaySection
          show={birthdayConfig?.show}
          mandatory={birthdayConfig?.mandatory}
          editable={birthdayConfig?.editable}
          birthdayEditState={birthdayEditState}
          setEditType={setEditType}
          userInfo={userInfo}
          birthday={birthday}
          setBirthday={setBirthday}
          language={language}
        />
      </Row>
    </>
  );
};

const MyAccountInfoSection = ({
  profileFieldsConfig,
  language,
  signUpMethod,
  countryCode,
  phoneNumber,
  email,
  userInfo,
}) => {
  const dispatch = useDispatch();
  const firstNameConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.firstName,
      )?.[0],
    [profileFieldsConfig],
  );
  const lastNameConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.lastName,
      )?.[0],
    [profileFieldsConfig],
  );
  const genderConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.gender,
      )?.[0],
    [profileFieldsConfig],
  );
  const birthdayConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.birthday,
      )?.[0],
    [profileFieldsConfig],
  );

  const [showLoginMethodModal, setShowLoginMethodModal] = useState(false);
  const [modalMethod, setModalMethod] = useState(null);
  const [showCustomerContactModal, setShowCustomerContactModal] =useState({
    show: false,
    isForSecondContact: false,
  });

  const closeCustomerContactModal = () => {
    setShowCustomerContactModal({
      show: false,
      isForSecondContact: false,
    });
  };

  const [editType, setEditType] = useState(null);
  const firstNameEditState = useMemo(() => {
    if (editType === ProfileEditType.FirstName) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const lastNameEditState = useMemo(() => {
    if (editType === ProfileEditType.LastName) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const contactForDirectMarketingEditState = useMemo(() => {
    if (editType === ProfileEditType.contactForDirectMarketing) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const genderEditState = useMemo(() => {
    if (editType === ProfileEditType.Gender) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const birthdayEditState = useMemo(() => {
    if (editType === ProfileEditType.Birthday) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);

  const countryCodeAndPhoneNumber = useMemo(
    () =>
      countryCode && phoneNumber ? `+${countryCode} ${phoneNumber}` : null,
    [countryCode, phoneNumber],
  );
  const showMobile = useMemo(
    () => [
      CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER,
      CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS,
    ].includes(signUpMethod),
    [signUpMethod],
  );
  const showEmail = useMemo(
    () => [
      CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS,
      CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS,
    ].includes(signUpMethod),
    [signUpMethod],
  );

  // check if show add login method button
  const showAddLoginMethodButton = useMemo(
    () => {
      if (!MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP) {
        return false;
      };
      if ([
        CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER,
        CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS,
      ].includes(signUpMethod)) {
        return true;
      };
      return false;
    },
    [signUpMethod],
  );

  // check if show second contact method button
  const showAddSecondContactButton = useMemo(
    () => {
      if (MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP) {
        return false;
      };
      if ([
        CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER,
        CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS,
      ].includes(signUpMethod)) {
        return true;
      };
      return false;
    },
    [signUpMethod],
  );

  const loadRecaptcha = () =>  {
    if (window?.grecaptcha && window?.grecaptcha?.enterprise) {
      console.log("reCAPTCHA already loaded");
      return;
    }

    const existingScript = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    if (existingScript) {
      console.log("reCAPTCHA script already exists");
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    
    script.onload = () => {
      if (window?.grecaptcha && window?.grecaptcha?.enterprise) {
        console.log("window.grecaptcha.enterprise ok")
      }
    };

    script.onerror = (error) => {
      console.error('load reCAPTCHA error:', error);
    };
  
    document.head.appendChild(script);
  }

  const removeRecaptcha = () => {
    const existingScript = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    if (existingScript) {
      existingScript.remove();
      console.log("reCAPTCHA script removed");
    }

    const recaptchaElements = document.querySelectorAll('.grecaptcha-badge, .grecaptcha-logo, iframe[src*="recaptcha"]');
    recaptchaElements.forEach(element => {
      element.remove();
    });

    if (recaptchaElements.length > 0) {
      console.log(`Removed ${recaptchaElements.length} reCAPTCHA DOM elements`);
    }

    if (window.grecaptcha) {
      delete window.grecaptcha;
      console.log("window.grecaptcha object removed");
    }

    const recaptchaStyles = document.querySelectorAll('link[href*="recaptcha"], style[data-href*="recaptcha"]');
    recaptchaStyles.forEach(style => {
      style.remove();
    });

    console.log("reCAPTCHA cleanup completed");
  }

  const showSecondLoginMethodModal = (editMethod) => {
    setEditType(ProfileEditType.LoginAndContact);
    setModalMethod(editMethod);
    setShowLoginMethodModal(true);
    if (USE_RECAPTCHA) {
      loadRecaptcha();
    }
  };

  const hideSecondLoginMethodModal = () => {
    setEditType(null);
    setShowLoginMethodModal(false);
    setModalMethod(null);
    if (USE_RECAPTCHA) {
      removeRecaptcha();
    }
  };

  const [firstName, setFirstName] = useState(userInfo.firstName);
  const [lastName, setLastName] = useState(userInfo.lastName);
  const [birthday, setBirthday] = useState(userInfo.birthday);
  const [selectedGender, setSelectedGender] = useState(userInfo.gender);
  useEffect(() => {
    setFirstName(userInfo.firstName);
    setLastName(userInfo.lastName);
    setBirthday(userInfo.birthday);
    setSelectedGender(userInfo.gender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editType]);

  useEffect(() => {
    return () => {
      dispatch({
        type: 'userInfoTemp/clearState',
        payload: {}
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container className="common-shadow-section-container account-info-section">
      <div className="common-section-title title-medium-2">
        {i18n.t('account_information')}
      </div>
      <Row>
        <FirstNameSection
          show={firstNameConfig?.show}
          mandatory={firstNameConfig?.mandatory}
          editable={firstNameConfig?.editable}
          firstNameEditState={firstNameEditState}
          setEditType={setEditType}
          userInfo={userInfo}
          firstName={firstName}
          setFirstName={setFirstName}
        />
        <LastNameSection
          show={lastNameConfig?.show}
          mandatory={lastNameConfig?.mandatory}
          editable={lastNameConfig?.editable}
          lastNameEditState={lastNameEditState}
          setEditType={setEditType}
          userInfo={userInfo}
          lastName={lastName}
          setLastName={setLastName}
        />
      </Row>
      <LoginOrContactSectionWithGenderAndBirthday
        language={language}
        contactForDirectMarketingEditState={contactForDirectMarketingEditState}
        setEditType={setEditType}
        email={email}
        showEmail={showEmail}
        countryCodeAndPhoneNumber={countryCodeAndPhoneNumber}
        showMobile={showMobile}
        signUpMethod={signUpMethod}
        showAddLoginMethodButton={showAddLoginMethodButton}
        showAddSecondContactButton={showAddSecondContactButton}
        showSecondLoginMethodModal={showSecondLoginMethodModal}
        hideSecondLoginMethodModal={hideSecondLoginMethodModal}
        setShowCustomerContactModal={setShowCustomerContactModal}
        genderConfig={genderConfig}
        genderEditState={genderEditState}
        userInfo={userInfo}
        selectedGender={selectedGender}
        setSelectedGender={setSelectedGender}
        birthdayConfig={birthdayConfig}
        birthdayEditState={birthdayEditState}
        birthday={birthday}
        setBirthday={setBirthday}
      />
      <LoginMethodContactModal
        showModal={showLoginMethodModal}
        modalMethod={modalMethod}
        onClose={() => hideSecondLoginMethodModal()}
        setShowCustomerContactModal={setShowCustomerContactModal}
      />
      <CustomerContactModal
        showCustomerContactModal={showCustomerContactModal}
        onClose={closeCustomerContactModal}
      />
    </Container>
  );
};

const mapStateToProps = ({ userInfoTemp, users, config }) => {
  return {
    ...userInfoTemp,
    profileFieldsConfig: config.profileFieldsConfig,
    language: users.language,
    signUpMethod: users.userInfo.signUpMethod,
    countryCode: users.userInfo.countryCode,
    phoneNumber: users.userInfo.phoneNumber,
    email: users.userInfo.emailAddress,
    userInfo: users.userInfo,
  };
};

export default connect(mapStateToProps)(
  withTranslation()(MyAccountInfoSection),
);
